export const tableConfig = {
  MONITORING: { name: 'emitovanje', singularName: 'emitovanje' },
  AUTHORS_WORK: { name: 'dela', singularName: 'dela' }, //TODO proveriti ova dva
  CODE_CODEBOOK_TYPES: {
    name: 'codeCodebookTypes',
    singularName: 'codeCodebookType',
    multiform: false,
    wideModal: false,
    checkName: (item) => item?.name,
    confirmDialogAdditionalInfo: true,
    processType: 'codeCodebooks',
    processDataFilterKey: 'codebookTypeId',
  },
  CODE_CODEBOOKS: {
    name: 'codeCodebooks',
    singularName: 'codeCodebook',
    confirmDialogAdditionalInfo: true,
    childrenType: 'codeChildrenCodebooks',
    showChildrenFilterKey: 'parentCodebookId',
    multiform: false,
    wideModal: false,
  },
  CODE_CHILDREN_CODEBOOKS: {
    name: 'codeChildrenCodebooks',
    singularName: 'codeChildrenCodebook',
    confirmDialogAdditionalInfo: true,
    multiform: false,
    wideModal: false,
  },
  COMPILATIONS: {
    name: 'compilations',
    singularName: 'compilation',
    multiform: true,
    wideModal: true,
    additionalTitleInfo: (item) => item?.title,
  },
};
